import React from 'react'
import newsletterConfig from '../../../newsletter-config.json'
import { NewsletterSectionRow, TableWrapper } from './helpersComponents'
import NewsletterContentText from './NewsletterContentText'
import splitArrayIntoChunks from '../../../functions/splitArrayIntoChunks'
import { headlineLargeBold } from './helpersTypo'


const MovieTd = ({itemData, movieWidth, movieHeight, cinemaProgramUrl, align, tdPadding, posterRadius}) => {
    const valign="top"
    
    if(itemData && itemData.hasOwnProperty('images') && itemData.images.hasOwnProperty('poster') && itemData.images.poster && itemData.images.poster.hasOwnProperty('url') && itemData.images.poster.url) {
        const url=itemData.images.poster.url
        const alt=itemData.images.poster.alt

        return (
            <td className="imageContent" align={align} valign={valign} style={tdPadding}>
                <a href={`${cinemaProgramUrl}?id=${itemData.id}`} target="_blank" style={{fontSize: '0px', lineHeight: 0}}>
                    <img 
                        className="flexibleImage" 
                        align="bottom" 
                        alt={alt} 
                        src={(url ? url : '')} 
                        width={movieWidth}
                        height={movieHeight}
                        style={{
                            maxWidth: movieWidth, 
                            maxHeight: movieHeight, 
                            display: "block", 
                            fontSize: 0, 
                            lineHeight: 0,
                            borderRadius: posterRadius ? posterRadius : 0
                        }}
                    />
                </a>
            </td>
        )
    } else {
        return (
            <td align={align} valign={valign} style={tdPadding}>
                <table
                    className="flexibleContainer"
                    width={movieWidth} 
                >
                </table>
            </td>
        )
    }
}

const MovieRows = ({itemIdsPairs, itemIdsPairsLength, items, movieWidth, movieHeight, lateralPadding, moviePaddingBottom, posterRadius, cinemaProgramUrl}) => {
    const trs = []

    for(let i = 0; i < itemIdsPairsLength; i++) {
        const itemIds = itemIdsPairs[i]
        const columns = []
        const isLast = i === itemIdsPairsLength - 1

        for(let j = 0; j < 3; j++) {
            const itemData = itemIds[j] ? items[itemIds[j]] : false

            let align 
            let tdPadding = {
                paddingRight: 0,
                paddingBottom: isLast ? 0 : moviePaddingBottom,
                paddingLeft: 0
            }

            if(0 === j)  {
                align = 'left'
                tdPadding.paddingRight = lateralPadding + 'px'
            } else if(1 === j) {
                align = 'center'
                tdPadding.paddingRight = (lateralPadding/2) + 'px'
                tdPadding.paddingLeft = (lateralPadding/2) + 'px'
            } else {
                align = 'right'
                tdPadding.paddingLeft = lateralPadding + 'px'
            }

            columns.push(<MovieTd 
                key={j}
                itemData={itemData}
                movieWidth={movieWidth}
                movieHeight={movieHeight}
                cinemaProgramUrl={cinemaProgramUrl}
                align={align}
                tdPadding={tdPadding}
                posterRadius={posterRadius}
            />)
        }

        trs.push(
            <tr key={i}>
                {columns}
            </tr>
        )
    }

    return trs
}


const NewsletterSectionMovies = ({id, items, cinemaData, newsletterData, structureItemData, stylesData, translation}) => {
    const chosenFont = stylesData.chosenFont
    const colorText = stylesData.secText
    const posterRadius = stylesData.posterRadius
    const movieWidth = (newsletterConfig.bodyWith - (newsletterConfig.moviesGridGap * 2)) / 3
    const movieHeight = 1.42 * movieWidth
    const moviePaddingBottom = newsletterConfig.moviesGridGap + 'px'
    const lateralPadding = (newsletterConfig.bodyWith / 3) - movieWidth 

    if(!newsletterData || !newsletterData[id] || 0 === newsletterData[id].length) {
        return null
    }

    const cinemaProgramUrl = cinemaData.cinemaProgramUrl
    const itemIds = newsletterData[id]
    const splitedItemIds  = splitArrayIntoChunks(itemIds, 3);
    const splitedItemIdsLength = splitedItemIds.length

    return ([
        <NewsletterSectionRow key='heading'>
            <TableWrapper>
                <tr>
                    <NewsletterContentText style={{paddingTop: "102px", paddingBottom: "34px"}}>
                        <h3 style={{...{color: colorText, textAlign: 'center'}, ...headlineLargeBold(chosenFont)}}>
                            {structureItemData.headlineFront ? structureItemData.headlineFront.toUpperCase() : ''}
                            {/* <NewsletterTranslation id="print_newsletter_preview_program" translation={translation} uppercase={true}>KINOPROGRAMM</NewsletterTranslation> */}
                        </h3>
                    </NewsletterContentText>
                </tr>
            </TableWrapper>
        </NewsletterSectionRow>,

        <NewsletterSectionRow key="movies">
            <TableWrapper>
                <MovieRows
                    itemIdsPairs={splitedItemIds}
                    itemIdsPairsLength={splitedItemIdsLength}
                    items={items}
                    movieWidth={movieWidth}
                    movieHeight={movieHeight}
                    lateralPadding={lateralPadding}
                    moviePaddingBottom={moviePaddingBottom}
                    posterRadius={posterRadius}
                    cinemaProgramUrl={cinemaProgramUrl}
                />
            </TableWrapper>
        </NewsletterSectionRow>
    ])
}

export default NewsletterSectionMovies